<template>
    <div class="flex justify-self-center items-center">
        <span class="uppercase md:text-md mr-2">{{ props.label }}</span>
        <button
            @click="changeLayout('grid')"
            :class="{ 'bg-(--area-text) text-(--area-highlight)!': props.modelValue === 'grid' }"
            class="size-12 text-(--area-text) rounded-3xl! overflow-clip!"
        >
            <Squares2X2Icon class="size-6" aria-hidden="true" />
        </button>
        <button
            @click="changeLayout('list')"
            :class="{ 'bg-(--area-text) text-(--area-highlight)!': props.modelValue === 'list' }"
            class="size-12 text-(--area-text) rounded-3xl! overflow-clip!"
        >
            <Bars3Icon class="size-6" aria-hidden="true" />
        </button>
    </div>
</template>

<script setup>
import { Bars3Icon, Squares2X2Icon } from "@heroicons/vue/20/solid";

const props = defineProps({
    modelValue: {
        type: String,
        required: true,
    },
    label: {
        type: String,
        default: "Layout",
    },
});

const emit = defineEmits(["update:modelValue"]);

function changeLayout(layout) {
    emit("update:modelValue", layout);
}
</script>
